import {
  IGfpaFactorContribution,
  IGfpaFactorContributionChartData,
} from '@/interfaces/gfpaReport.interface'

export const getTransformedFactorContributionChartData = (
  data: IGfpaFactorContribution[],
  filterKey: string,
): IGfpaFactorContributionChartData[] => {
  const outputData = Object.values(
    data.reduce<Record<string, IGfpaFactorContributionChartData>>(
      (acc, item: any) => {
        const category = item[filterKey] as string
        if (!acc[category]) {
          acc[category] = {
            category: category,
            portfolio: 0,
            benchmark: 0,
            difference: 0,
            type: filterKey,
          }
        }
        acc[category].portfolio += item.portfolio_total_return || 0
        acc[category].benchmark += item.benchmark_total_return || 0
        acc[category].difference += item.active_total_return || 0

        return acc
      },
      {},
    ),
  )
  return outputData
}
